module.exports = { "default": require("core-js/library/fn/math/log10"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./~/babel-runtime/core-js/math/log10.js
// module id = j9JH
// module chunks = 5